<script setup>
    const { data: siteData } = await useStatamicGlobals().getGlobal({
        handle: 'site',
    })

    const { data: companyData } = await useStatamicGlobals().getGlobal({
        handle: 'company',
    })

    const copyrightText = () =>
        siteData.value.copyright_text?.replace(
            '{{ current_year }}',
            new Date().getFullYear(),
        )
</script>

<template>
    <footer
        class="xl:lg-20 mt-auto bg-brand1 py-8 text-center text-white sm:py-12 lg:py-16"
    >
        <div class="container">
            <p class="text-center">
                <img
                    :src="companyData.logo_alt?.permalink"
                    class="relative mx-auto"
                    width="265"
                    height="36"
                />
                
                <img
                    src="@/assets/images/ao-certified-logo.png"
                    class="relative mx-auto mt-4 max-w-[100px]"
                />
            </p>

            <NavMenu
                handle="footer"
                class="mx-auto mt-8 inline-flex text-xs md:mt-5"
            />
            <p class="mt-2 text-xs">{{ copyrightText() }}</p>
        </div>
    </footer>
</template>
